import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React, { useRef } from 'react';
import styled from 'styled-components';
import { Interpolation } from 'chartist';
import { useTranslation } from 'react-i18next';
import useChartist from 'hooks/useChartist';
import { pxToRem } from 'utils/ui/units';
import { typeScale, spacing } from 'styles/globals';
import { getColorBlock } from 'utils/ui/colors';
import Flex from 'components/Flex';
import ChartTooltips from '../ChartTooltips';
import { jsx as _jsx } from "react/jsx-runtime";
var ChartWrapper = styled.div.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['chartColor', 'isEmpty', 'chartHeight', 'highlightIndex', 'totalLabels'].includes(prop);
  }
}).withConfig({
  displayName: "ChartWithPoints__ChartWrapper",
  componentId: "sc-d8zs3x-0"
})(["position:relative;height:", ";&:hover{cursor:pointer !important;}> svg{vertical-align:middle;color:", ";overflow:visible;}.ct-series{stroke:", ";}.ct-line{fill:none;stroke:currentColor;stroke-width:4px;}.ct-area{fill:currentColor;opacity:0.1;}.ct-label{color:", ";font-size:", ";display:block;width:", " !important;margin-left:-", ";white-space:pre-wrap;text-align:center;}.ct-label.ct-vertical{display:flex;align-items:flex-end;justify-content:flex-end;height:100%;margin:0;padding:0;line-height:1;}.ct-point{stroke-width:", "};stroke-linecap:round;}.ct-grid{display:none;}.ct-grid:nth-child(", "):nth-last-child(", "){display:block;stroke:", ";}", ""], function (p) {
  return pxToRem(p.chartHeight);
}, function (p) {
  return getColorBlock(p.chartColor, p.theme);
}, function (p) {
  return getColorBlock(p.chartColor, p.theme);
}, function (p) {
  return getColorBlock('text', p.theme);
}, typeScale.xxxs, pxToRem(20), spacing.xs, pxToRem(8), function (p) {
  return p.highlightIndex + 1;
}, function (p) {
  return p.totalLabels - p.highlightIndex;
}, function (p) {
  return getColorBlock(p.chartColor, p.theme);
}, function (p) {
  return p.isEmpty && "\n\t\t.ct-line {\n\t\t\topacity: 0.2;\n\t\t\tstroke-dasharray: 10;\n\t\t}\n\t\t.ct-area {\n\t\t\topacity: 0;\n\t\t}\n\t";
});
function ChartWithPoints(_ref) {
  var _customisedOptions$ax;
  var emptyMessage = _ref.emptyMessage,
    labels = _ref.labels,
    data = _ref.data,
    getTooltipReadout = _ref.getTooltipReadout,
    selectedValue = _ref.selectedValue,
    _ref$chartColor = _ref.chartColor,
    chartColor = _ref$chartColor === void 0 ? 'chart' : _ref$chartColor,
    _ref$minimumDataPoint = _ref.minimumDataPoints,
    minimumDataPoints = _ref$minimumDataPoint === void 0 ? 2 : _ref$minimumDataPoint,
    _ref$chartHeight = _ref.chartHeight,
    chartHeight = _ref$chartHeight === void 0 ? 125 : _ref$chartHeight,
    options = _ref.options,
    showAllLabels = _ref.showAllLabels,
    labelClicks = _ref.labelClicks;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var hostRef = useRef(null);
  var filteredData = data === null || data === void 0 ? void 0 : data.filter(function (item) {
    return item !== null;
  });
  var hasData = filteredData.length >= minimumDataPoints;
  var shouldShowLabel = function shouldShowLabel(index) {
    var lastIndex = labels.length - 1;
    return index === 0 || index === lastIndex || labels[index] === selectedValue;
  };
  var responsiveLabels = showAllLabels ? labels : labels.map(function (label, index) {
    return shouldShowLabel(index) ? label : '';
  });
  var defaultOptions = {
    showArea: true,
    showPoint: hasData,
    lineSmooth: Interpolation.cardinal({
      fillHoles: true
    }),
    fullWidth: true,
    chartPadding: {
      top: 4,
      // Ensure the x-axis labels are not cut off
      bottom: 20,
      left: 0,
      right: 0
    },
    axisX: {
      showGrid: hasData,
      showLabel: hasData,
      labelInterpolationFnc: function labelInterpolationFnc(value, index) {
        return showAllLabels || shouldShowLabel(index) ? value : null;
      }
    },
    axisY: {
      offset: 0,
      showLabel: false,
      showGrid: false,
      low: 0
    }
  };
  var customisedOptions = _objectSpread(_objectSpread({}, defaultOptions), options);
  useChartist(hostRef, {
    type: 'Line',
    data: {
      labels: responsiveLabels,
      series: filteredData.length ? [data] : []
    },
    options: customisedOptions
  });
  var filteredLabels = responsiveLabels.filter(function (label) {
    return Boolean(label) && label !== '';
  });
  var highlightIndex = selectedValue ? filteredLabels.indexOf(selectedValue) : -1;
  // The tooltip component takes the full width of the svg graph.
  // If we show the labels on y axis, the padding needs to be adjusted, otherwise tooltips will be showing on wrong places.
  var tooltipPaddingValue = (_customisedOptions$ax = customisedOptions.axisY) !== null && _customisedOptions$ax !== void 0 && _customisedOptions$ax.showLabel ? 40 : 0;
  return /*#__PURE__*/_jsx(ChartWrapper, {
    ref: hostRef,
    chartColor: chartColor,
    chartHeight: chartHeight,
    isEmpty: !hasData,
    highlightIndex: highlightIndex,
    totalLabels: filteredLabels.length,
    children: hasData ? /*#__PURE__*/_jsx(ChartTooltips, {
      data: data,
      labels: labels,
      getTooltipReadout: getTooltipReadout,
      pl: tooltipPaddingValue,
      labelClicks: labelClicks
    }) : /*#__PURE__*/_jsx(Flex, {
      dimmed: true,
      justifyContent: "center",
      alignItems: "top",
      height: "100%",
      children: emptyMessage || t('empty_no_data')
    })
  });
}
export default ChartWithPoints;